export const initialState = {
  notifications: [],
  poll: undefined,
  lastPoll: new Date(),
  notificationDuration: 25000,
  notificationInterval: 60000 * 10,
  displayNotification: undefined,
  currentPage: 1,
  nextPage: '',
}
